import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {RegistrationIdImport} from '../../../shared/interface/registration-id-import';

export interface ImportResultDialogData {
  registrationIdImportObject: RegistrationIdImport;
}

@Component({
  selector: 'app-import-result-dialog',
  templateUrl: './import-result-dialog.component.html',
  styleUrls: ['./import-result-dialog.component.scss']
})
export class ImportResultDialogComponent {

  registrationIdImport: RegistrationIdImport;

  constructor(
    public dialogRef: MatDialogRef<ImportResultDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImportResultDialogData,
  ) {
    this.registrationIdImport = data.registrationIdImportObject;
  }

}
